export class Profile {
  myEmail: string;
  emailInvalid: boolean;
  myGender: string;
  isMarital: boolean;
  quantityBoys = 0;
  quantityGirls = 0;
  completed = false;
  dob: string;
  customerId: string;
  userProfile: {
    email: string;
    gender: number;
    age: number;
    kids: number;
    marital: number;
    smoked: number;
    countrycode: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
  };

  getQuestion(isQuickKyc = false, isWhatsAppRegister = false) {
    let questions: any[] = [];

    questions.push({
      key: 'gender',
      label: 'My Gender',
      order: 3,
      required: false,
      controlType: 'radio',
      type: 'radio',
      className: 'c-gender',
      value: '',
      options: [
        { value: 1, checked: false, classIcon: 'icon-ic_male', name: 'male' },
        {
          value: 0,
          checked: false,
          classIcon: 'icon-ic_female',
          name: 'female'
        }
      ]
    });

    if (!isWhatsAppRegister) {
      questions.push(
        {
          key: 'email',
          label: 'My Email',
          order: 1,
          required: true,
          controlType: 'textbox',
          type: 'email'
        },
        {
          key: 'age',
          value: '',
          required: true,
          order: 2,
          controlType: 'textbox',
          type: 'number'
        }
      );
    }

    if (!isQuickKyc) {
      questions.push(
        {
          key: 'marital',
          label: 'My marital status',
          order: 4,
          required: false,
          controlType: 'radio',
          type: 'radio',
          className: 'c-family',
          value: '',
          options: [
            {
              value: 1,
              checked: false,
              classIcon: 'icon-ic_male',
              name: 'alone'
            },
            {
              value: 0,
              checked: false,
              classIcon: 'icon-icon_married',
              name: 'married'
            }
          ]
        },
        {
          key: 'kids',
          label: 'My kid(s)',
          order: 5,
          required: false,
          controlType: 'checkbox',
          type: 'checkbox',
          options: {
            kidBoys: [
              { value: 'kid_boy_1', classIcon: 'icon-ic_boy', checked: false },
              { value: 'kid_boy_2', classIcon: 'icon-ic_boy', checked: false },
              { value: 'kid_boy_3', classIcon: 'icon-ic_boy', checked: false },
              { value: 'kid_boy_4', classIcon: 'icon-ic_boy', checked: false },
              { value: 'kid_boy_5', classIcon: 'icon-ic_boy', checked: false }
            ],
            kidGirls: [
              { value: 'kid_girl_1', classIcon: 'icon-ic_girl', checked: false },
              { value: 'kid_girl_2', classIcon: 'icon-ic_girl', checked: false },
              { value: 'kid_girl_3', classIcon: 'icon-ic_girl', checked: false },
              { value: 'kid_girl_4', classIcon: 'icon-ic_girl', checked: false },
              { value: 'kid_girl_5', classIcon: 'icon-ic_girl', checked: false }
            ]
          }
        },
        {
          key: 'smoked',
          label: 'I smoked in the past 12 months ',
          order: 6,
          required: false,
          controlType: 'radio',
          type: 'radio',
          className: 'c-family',
          value: '',
          options: [
            {
              value: 1,
              checked: false,
              classIcon: 'icon-icon-yes',
              name: 'alone'
            },
            {
              value: 0,
              checked: false,
              classIcon: 'icon-icon-no',
              name: 'married'
            }
          ]
        }
      );
    }

    return questions;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/profile.ts